import authApi from '@/api/auth'
import { setItem, getItem } from '@/helpers/persistanceStorage'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    isSubmitting: false,
    currentUser: null,
    validationErrors: null,
    isLoggedIn: false,
    isLoading: false,
    errors: {},
  },
  mutations: {
    LOGIN_START (state) {
      state.isSubmitting = true
      state.validationErrors = null
      state.errors = {}
    },
    LOGIN_FAILURE (state, errorMessage) {
      state.isSubmitting = false
      state.validationErrors = errorMessage
      state.isLoggedIn = false
    },
    LOGIN_SUCCESS (state, user) {
      state.isLoggedIn = true
      state.isSubmitting = false
      state.currentUser = user
      state.validationErrors = null
      state.errors = {}
    },
    GET_CURR_USER_START (state) {
      state.isLoading = true
    },
    GET_CURR_USER_SUCCESS (state, payload) {
      state.isLoggedIn = true
      state.isLoading = false
      state.currentUser = payload
    },
    GET_CURR_USER_FAILURE (state) {
      state.isLoggedIn = false
      state.isLoading = false
      state.currentUser = null
    },
    RESET_ALL (state) {
      state.isLoggedIn = false
      state.isLoading = false
      state.isSubmitting = false
      state.currentUser = null
      state.validationErrors = null
      state.errors = {}
      setItem('accessToken', null)
    },
    SET_ERRORS (state, payload) {
      state.errors = payload || {}
    },
  },
  actions: {
    async login (context, credentials) {
      try {
        context.commit('LOGIN_START')
        const response = await authApi.login(credentials)
        
        // API может возвращать access или token
        const token = response.data.token || response.data.access
        if (token) {
          setItem('accessToken', token)
        }
        
        const user = response.data.user
        if (user) {
          context.commit('LOGIN_SUCCESS', user)
          Vue.notify({
            title: 'Успешно',
            type: 'success',
            text: 'Вы успешно вошли в систему',
          })
          return user
        } else {
          throw new Error('No user data in response')
        }
      } catch (error) {
        context.commit('LOGIN_FAILURE', error.response?.data?.message || 'Ошибка входа')
        context.commit('SET_ERRORS', error.response?.data || {})
        
        if (error.response) {
          if (error.response.status === 422) {
            Vue.notify({
              title: 'Ошибка',
              type: 'error',
              text: 'Неверные данные для входа',
            })
          } else if (error.response.status === 401) {
            Vue.notify({
              title: 'Ошибка',
              type: 'error',
              text: 'Неверный email или пароль',
            })
          } else {
            Vue.notify({
              title: 'Ошибка',
              type: 'error',
              text: error.response.data?.message || 'Произошла ошибка при входе',
            })
          }
        } else {
          Vue.notify({
            title: 'Ошибка',
            type: 'error',
            text: 'Не удалось подключиться к серверу',
          })
        }
        
        throw error
      }
    },

    async getCurrentUser (context) {
      try {
        context.commit('GET_CURR_USER_START')
        const response = await authApi.getCurrentUser()
        context.commit('GET_CURR_USER_SUCCESS', response.data)
        return response.data
      } catch (error) {
        context.commit('GET_CURR_USER_FAILURE')
        // Если ошибка 401, очищаем состояние
        if (error.response && error.response.status === 401) {
          context.commit('RESET_ALL')
        }
        throw error
      }
    },

    async refreshToken (context) {
      try {
        const response = await authApi.refresh()
        
        // API может возвращать access, token или refresh
        const newToken = response.data.token || response.data.access || response.data.refresh
        if (newToken) {
          setItem('accessToken', newToken)
          // Обновляем пользователя, если он есть в ответе
          if (response.data.user) {
            context.commit('GET_CURR_USER_SUCCESS', response.data.user)
          }
          return response.data
        } else {
          throw new Error('No token in refresh response')
        }
      } catch (error) {
        // Если refresh не удался, очищаем состояние
        context.commit('RESET_ALL')
        throw error
      }
    },

    async logout (context) {
      try {
        // Пытаемся вызвать API для выхода, даже если токен уже недействителен
        const token = getItem('accessToken')
        if (token) {
          try {
            // Если есть logout endpoint, вызываем его
            // await authApi.logout()
          } catch (error) {
            // Игнорируем ошибки при выходе (токен может быть уже недействителен)
            console.warn('Logout API error:', error)
          }
        }
      } finally {
        // Очищаем состояние в любом случае
        context.commit('RESET_ALL')
      }
    },
  },
  getters: {
    currentUser (state) {
      return state.currentUser
    },
    loggedIn (state) {
      return state.isLoggedIn && !!getItem('accessToken')
    },
    isSubmitting (state) {
      return state.isSubmitting
    },
    isLoading (state) {
      return state.isLoading
    },
  },
}
